export const DEFAULT_PROMO_ID = parseInt(process.env.VUE_APP_DEFAULT_PROMO_ID);